import { t } from "i18next";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getAppConfig, updateAppConfig } from "services/customAPI";
import { DTO } from "shared-lib";

function SwitchButton() {
  const [isOn, setIsOn] = useState(false);
  const [useMocks, setUseMocks] = useState<DTO.AppDto>({
    name: "USE_MOCKS",
    value: "false",
    placeHolder: "Usar dados mocados",
    active: false,
  });

  const [isLoading, setIsLoading] = useState(false);
  const handleToggle = () => {
    if (!useMocks) return;

    const updatedConfig = {
      ...useMocks,
      value: useMocks.value === "true" ? "false" : "true",
    };

    fetchConfigs(updatedConfig);
  };

  const fetchConfigs = async (config: DTO.AppDto) => {
    setIsLoading(true);
    try {
      const response = await updateAppConfig(config.name, config);
      if (response?.data) {
        toast.success(t("Configuração atualizada com sucesso"));
        setUseMocks(response.data);
      }
    } catch (error) {
      console.error("Erro ao atualizar configurações!", error);
      toast.error(t("Erro ao atualizar configuração"));
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (useMocks) {
      setIsOn(useMocks.value === "true");
    }
  }, [useMocks]);
  useEffect(() => {
    const getConfig = async () => {
      try {
        const response = await getAppConfig("USE_MOCKS");
        if (response.data) {
          setUseMocks(response.data);
        }
      } catch (error) {
        console.error("Erro ao buscar configuração!", error);
      }
    };

    getConfig();
  }, []);

  return (
    <div
      onClick={handleToggle}
      style={{
        width: 100,
        margin: 15,
        zIndex: 111,
        height: 40,
        border: "1px solid #4cd137",
        backgroundColor: isOn ? "#4cd137" : "#ccc",
        borderRadius: 20,
        display: "flex",
        alignItems: "center",
        justifyContent: isOn ? "flex-end" : "flex-start",
        cursor: "pointer",
        position: "relative",
        transition: "background-color 0.3s",
      }}
    >
      {useMocks ? (
        <>
          <div
            style={{
              width: 70,
              height: 37,
              backgroundColor: "#fff",
              borderRadius: 20,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 14,
              fontWeight: "bold",
              color: "#4cd137",
              transition: "all 0.3s",
            }}
          >
            {useMocks.value === "true" ? "Demo" : "Produção"}
          </div>
        </>
      ) : (
        <></>
      )}
    </div>
  );
}

export default SwitchButton;
